export default "__VITE_ASSET__BROVIEuO__"